var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Aktualnosci",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "aktualnosci---artykul---3-podglad",
    transform: "translate(-440.000000, -67.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(440.000000, 67.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.49414005,11.5337376 C3.71509144,11.5337376 1.45399384,9.27318866 1.45399384,6.49414005 C1.45399384,3.71509144 3.71509144,1.45399384 6.49414005,1.45399384 C9.27263998,1.45399384 11.5337376,3.71509144 11.5337376,6.49414005 C11.5337376,9.27318866 9.27263998,11.5337376 6.49414005,11.5337376 M14.8976758,14.0247308 L14.8976758,14.0247308 L11.4980736,10.6245799 L11.5518439,10.5570927 C12.4911788,9.39005684 12.9877314,7.98489525 12.9877314,6.49414005 C12.9877314,2.91347446 10.074257,0 6.49414005,0 C2.91347446,0 0,2.91347446 0,6.49414005 C0,10.0748056 2.91347446,12.9877314 6.49414005,12.9877314 C7.90149635,12.9877314 9.24630349,12.536719 10.3826134,11.682429 L10.449552,11.6324994 L13.8700039,15.0529514 C14.143245,15.3267411 14.6244347,15.3267411 14.8976758,15.0529514 C15.0353937,14.9157821 15.1111111,14.7330727 15.1111111,14.5388411 C15.1111111,14.3446095 15.0353937,14.1619 14.8976758,14.0247308",
    id: "Fill-1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.13f19c7581435a6b1e0de6615deb3252.svg";
export { ForwardRef as ReactComponent };